import Service from './Service';
import { createApi } from '@stilingue/st-auth-utils';

const gateway = process.env.VUE_APP_SERVICES_PROXY_URL || '';

const afterParser = (response) => {
  return response.data;
};

class PerformanceService extends Service {
  constructor(gateway) {
    const api = createApi('/performance', gateway, {
      authNotFound: () => true,
    });
    super(api, { afterParser });
  }

  facebookComparisonKeymetrics(params = {}) {
    return this.find({
      ...params,
      url: '/facebook/comparison/keymetrics',
    });
  }

  reportCallsQuantity(params = {}) {
    return this.find({
      ...params,
      url: '/report/calls_quantity',
    });
  }

  metricsOverview(params = {}) {
    return this.find({
      ...params,
      url: '/page/overview',
    });
  }

  metricsFanEvolution(params = {}) {
    return this.find({
      ...params,
      url: '/page/fan_evolution',
    });
  }

  cases(params = {}) {
    return this.find({
      ...params,
      url: '/sac/feed',
    });
  }
}

export default new PerformanceService(gateway);
